export function getAlertText(cards: string[]): string {
  if (cards.length === 1) {
    return `your card ending in ${cards[0]}`;
  }
  if (cards.length > 1) {
    const last = cards[cards.length - 1];
    const rest = cards.slice(0, -1).join(', ');
    return `one of your cards ending in ${rest} or ${last}`;
  }
  return 'one of your cards';
}
